import sortBy from 'lodash/sortBy'
import { createSelector } from 'reselect'

export const getRentalFees = createSelector([state => state?.rentalFees, state => state?.hideArchived], (rentalFees = [], hideArchived) => {
  const filteredRows = hideArchived ? rentalFees.filter(({ archived }) => !archived) : rentalFees
  const sortedRows = sortBy(filteredRows, ['archived', 'feeName'])

  return sortedRows
})
